import React, { useEffect, useRef, useState } from "react";
import { LogoIcon } from "../../icons";
import isMobileDevice from "../../../utils/isMobileDevice";
import styles from "./styles.module.css";

export const Footer = ({
  newMessageText,
  setNewMessageText,
  onSubmit,
  isLoading,
  additionalText,
  poweredByText,
  logoLink,
  isDisabled,
}) => {
  const textareaRef = useRef(null);
  const isMobile = isMobileDevice();

  const [isSubmitting, setIsSubmitting] = useState(false);

  // stock widget
  const stockWidgetContainerRef = useRef(null);
  const [setContainerWidth] = useState(0);

  useEffect(() => {
    const containerElement = stockWidgetContainerRef.current;

    const resizeObserver = new ResizeObserver((entries) => {
      for (let entry of entries) {
        const width = entry.contentRect.width;
        setContainerWidth(width);
      }
    });

    if (containerElement) {
      resizeObserver.observe(containerElement);
    }

    // Cleanup observer on unmount
    return () => {
      if (containerElement) {
        resizeObserver.unobserve(containerElement);
      }
    };
  }, []);

  const handleKeyDown = (e) => {
    if (!isMobile && e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      if (isSubmitting || isDisabled) return;

      setIsSubmitting(true);
      onSubmit();
      setTimeout(() => setIsSubmitting(false), 3000);
    }
  };

  const handleClick = (e) => {
    e.preventDefault();
    if (isSubmitting || isDisabled) return;

    setIsSubmitting(true);
    onSubmit();
    setTimeout(() => setIsSubmitting(false), 3000); // Reset flag after a delay (3s)
  };

  return (
    <div className={styles.footerContainer}>
      <form className={styles.footerBox} onSubmit={(e) => e.preventDefault()}>
        <textarea
          ref={textareaRef}
          placeholder="Ask anything about the companies you've selected..."
          className={styles.footerBoxTextarea}
          rows={1}
          value={newMessageText}
          onKeyDown={handleKeyDown}
          onChange={(e) => setNewMessageText(e.target.value)}
          // style={{ lineHeight: `${currentLineHeight}px` }}
        />

        <button
          disabled={isDisabled || isLoading}
          className={styles.footerButton}
          type="button"
          onClick={handleClick}
          onDoubleClick={(e) => e.preventDefault()}
        >
          {isLoading ? (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="white"
              stroke="black"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className={`icon icon-tabler icons-tabler-outline icon-tabler-loader infiniteRotating`}
            >
              <path stroke="none" d="M0 0h24v24H0z" fill="none" />
              <path d="M12 6l0 -3" />
              <path d="M16.25 7.75l2.15 -2.15" />
              <path d="M18 12l3 0" />
              <path d="M16.25 16.25l2.15 2.15" />
              <path d="M12 18l0 3" />
              <path d="M7.75 16.25l-2.15 2.15" />
              <path d="M6 12l-3 0" />
              <path d="M7.75 7.75l-2.15 -2.15" />
            </svg>
          ) : (
            <svg
              width="24"
              height="22"
              viewBox="0 0 24 22"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M0.291992 0.665039L24.002 11L0.292992 21.336L3.93999 11L0.291992 0.665039ZM5.70799 12L3.70799 17.665L18.999 11L3.70799 4.33604L5.70799 10H11V12H5.70799Z"
                fill="black"
              />
            </svg>
          )}
        </button>
      </form>

      <div className={styles.poweredContainer}>
        {!!additionalText && (
          <p className={`chatBotFont ${styles.additionalText}`}>
            aiiro can make mistakes and doesn't give financial advice. More
            specific questions will result in better responses. Validate
            important information.
          </p>
        )}

        <div className={styles.poweredBox}>
          <span className="chatBotFont">{poweredByText}</span>
          <a href={logoLink || "#"} target="_blank" rel="noreferrer">
            <div
              className={styles.badgeIcon}
              style={{
                width: "50px",
                height: "18px",
              }}
            >
              <LogoIcon width="50px" height="18px" />
            </div>
          </a>
        </div>
      </div>
    </div>
  );
};
